import * as React from "react";
import {Component, Fragment} from "react";
import KeySolver from "./KeySolver";

class Untouched extends Component {

	constructor(props) {
		super(props);
	}

	render() {

		const {children} = this.props;

		return (
			<Fragment>
				<div id="untouched" className="d-none">
					{children.length > 0 &&
						<Fragment>
							<ul>
								{children.map(item =>
										<Fragment key={KeySolver()} >
											<li>
												<p>{item.properties.title}</p>
												{item.children.length > 0 &&
													<ul>
														<Fragment>
															{item.children.map(item =>
																<Fragment key={KeySolver()} >
																	<li>
																		<p>{item.properties.title}</p>
																		{item.properties.inputType === 'checkbox' &&
																			<input type="checkbox" id={item.properties.id} />
																		}
																		{item.properties.inputType !== 'checkbox' &&
																			<input type="text" id={item.properties.id} />
																		}
																		{item.children.length > 0 &&
																			<Fragment>
																				{item.children.map((children, i) =>
																					<Fragment key={KeySolver()} >
																						<input type="radio" name={item.properties.id} id={children.properties.id} defaultChecked={children.properties.checked ? children.properties.checked : false} />
																					</Fragment>
																				)}
																			</Fragment>
																		}
																		{item.properties.items &&
																			<Fragment>
																				{item.properties.items.length > 0 &&
																					<ul>
																						<Fragment>
																							{item.properties.items.map(itemItem =>
																								<Fragment
																									key={KeySolver()}>
																									<button
																										type="button"
																										id={`${itemItem.id}`}>{itemItem.id}</button>
																									{item.properties.inputType && item.properties.inputType === 'patternVolant' &&
																										<Fragment>
																											<button
																												type="button"
																												id={`${itemItem.id}_V`}>{itemItem.id}</button>
																											<button
																												type="button"
																												id={`${itemItem.id}_VV900`}>{itemItem.id}</button>
																											<button
																												type="button"
																												id={`${itemItem.id}_VV1500`}>{itemItem.id}</button>
																										</Fragment>
																									}
																								</Fragment>
																							)}
																						</Fragment>
																					</ul>
																				}
																			</Fragment>
																		}
																	</li>
																</Fragment>
															)}
														</Fragment>
													</ul>
												}
											</li>
										</Fragment>
								)}
							</ul>
						</Fragment>
					}
					<input type="checkbox" id="check-animation"/>
					<input type="checkbox" id="check-background"/>
				</div>
			</Fragment>
		);
	}
}

export default Untouched;
